exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scroll-height{margin-bottom:1.8rem}.unpay-goPay{position:absolute;height:1.8rem;bottom:0;background-color:#fff;width:100%}.unpay-money{float:left;margin-left:.8rem;line-height:1.8rem;font-size:.48rem}.goPay{float:right;background:#fdbf03;width:6.25rem;text-align:center;line-height:2.25rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3370b0b2","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/clinic/ClinicUnpayDetail.vue
// module id = 429
// module chunks = 0